import PropTypes from "prop-types";
import React, { Component } from "react";
import ImageEditor from "../ImageEditor/ImageEditor";
import "./AvatarEditor.scss";

class AvatarEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: {
        file: null,
        zoom: 0,
        rotation: 0,
        position: {
          x: 0.5,
          y: 0.5,
        },
      },
    };
  }

  render = () => {
    const {
      defaultImage,
      defaultZoom,
      defaultRotation,
      defaultPosition,

      forceImage,
      forceZoom,
      forceRotation,
      forcePosition,

      onUpdateImage,

      validAttachmentTypes,
      maxSize,
      onDropRejected,
      onError,
      onClose,
    } = this.props;
    const { file, zoom, rotation, position } = this.state.image;

    return (
      <div className="AvatarEditor">
        <ImageEditor
          defaultImage={defaultImage}
          defaultZoom={defaultZoom}
          defaultRotation={defaultRotation}
          defaultPosition={defaultPosition}
          forceImage={forceImage}
          forceZoom={forceZoom}
          forceRotation={forceRotation}
          forcePosition={forcePosition}
          file={file}
          zoom={zoom}
          rotation={rotation}
          position={position}
          changeImageProperty={({ key, value }) =>
            this.setState((prevState) => ({
              image: {
                ...prevState.image,
                [key]: value,
              },
            }))
          }
          onUpdateImage={onUpdateImage}
          validAttachmentTypes={validAttachmentTypes}
          maxSize={maxSize}
          onDropRejected={onDropRejected}
          onError={onError}
          onClose={onClose}
        />
      </div>
    );
  };
}

AvatarEditor.propTypes = {
  defaultImage: PropTypes.string,
  defaultZoom: PropTypes.number,
  defaultRotation: PropTypes.number,
  defaultPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),

  forceImage: PropTypes.string,
  forceZoom: PropTypes.number,
  forceRotation: PropTypes.number,
  forcePosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),

  onUpdateImage: PropTypes.func,
  onError: PropTypes.func,
  onClose: PropTypes.func,

  validAttachmentTypes: PropTypes.object,
  maxSize: PropTypes.number,
  onDropRejected: PropTypes.func,
};

export default AvatarEditor;
